import Client from '../../../services/client';
import type { ConfirmPaymentInfo } from '../../../types';

interface ConfirmCreditCardTransactionProps {
  confirmPaymentInfo: ConfirmPaymentInfo;
}

export const confirmCreditCardTransaction = async ({
  confirmPaymentInfo,
}: ConfirmCreditCardTransactionProps) => {
  const { data } = await Client.authApsCreditCard({
    parkingTicketTransactionId: confirmPaymentInfo.createTransactionId,
    token: confirmPaymentInfo.token as string,
    transactionId: confirmPaymentInfo.merchantTransactionId,
  });

  return data;
};
